import React from 'react';
import {  Tooltip, Legend, LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { formatNumber } from 'utils/numberUtil';
import { numberFormatter } from 'utils/tableUtils';

const AnyaVisualizationLine = ({showVisualization, visualisation, COLORS}) => {
    const data = visualisation?.data || [];
    const colors = visualisation?.color;
    return showVisualization && (
        <div style={{ marginTop: 16, border: "1px solid #d9d9d9", borderRadius: "4px", width: 'fit-content', padding: "10px" }}>
            <h4>{visualisation.title}</h4>
            <ResponsiveContainer width={700} height={400}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey={"dataKey"} />
                    <YAxis tickFormatter={numberFormatter} />
                    <Legend />
                    <Tooltip  formatter={formatNumber}/>
                    
                    {data[0] && Object.keys(data[0]).filter(key => key!=="dataKey").map((key, index) => {
                       return <Line key={key} type="monotone" dataKey={key} name={key} stroke={colors ? colors[key] : COLORS[index]} />
                    }
                    )}
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
};

export default AnyaVisualizationLine;